import { useEffect, useState } from 'react';

export const useProductComparator = () => {
    const [selectedProducts, setSelectedProducts] = useState<Set<number>>(new Set());
    const [selectedType, setSelectedType] = useState<undefined | 'corn' | 'soy' | 'crop_protection'>();

    const selectProduct = ({ id }: { id: number }) => {
        const newSet = new Set(selectedProducts);
        if (newSet.has(id)) {
            newSet.delete(id);
        } else {
            newSet.add(id);
        }
        setSelectedProducts(newSet);
    };

    const resetAndSelectMultipleProducts = (ids: number[]) => {
        setSelectedProducts(new Set(ids));
    };

    const isSelected = ({ id }: { id: number }) => {
        return selectedProducts.has(id);
    };

    const getTypeOfIds = ({
        cornProductProfileId,
        soyProductProfileId,
        cropProtectionProductId,
    }: {
        cornProductProfileId?: number;
        soyProductProfileId?: number;
        cropProtectionProductId?: number;
    }) => {
        if (cornProductProfileId) {
            return 'corn';
        }
        if (soyProductProfileId) {
            return 'soy';
        }
        if (cropProtectionProductId) {
            return 'crop_protection';
        }
        return null; // Return null if no ID matches
    };

    const resetSelectedProducts = () => {
        setSelectedProducts(new Set());
    };

    useEffect(() => {
        if (selectedProducts.size === 0) setSelectedType(undefined);
    }, [selectedProducts]);

    return {
        selectedProducts,
        resetSelectedProducts,
        selectProduct,
        isSelected,
        resetAndSelectMultipleProducts,
        getTypeOfIds,
        selectedType,
        setSelectedType,
    };
};
